import { Injectable } from '@angular/core';
import { ReplaySubject, Observable } from 'rxjs';
import { Menu } from '../../modules/common/menu/models/menu';

@Injectable({
  providedIn: 'root'
})
export class PageHeadingService {

  constructor() { }

  private _menu: ReplaySubject<Menu> = new ReplaySubject<Menu>(1);
  public menu$ = this._menu.asObservable();

  public menuOnChange(menu: Menu) {
    this._menu.next(menu);
  }
}
